export const ACCEPTED_IMAGE_FORMATS = ".jpg,.jpeg,.png";
